export default __webpack_public_path__ + "static/media/12t.8a445b98.jpg";